module.exports = __webpack_public_path__ + "static/media/importFlybook3.b2fbaf12.png";